import {
  FETCH_SHOPINFO,
  UPDATE_SHOP_INFO,
  UPDATE_CAN_ADD_ACTION,
  UPDATE_DASHBOARD_REPORT,
  SET_CURRENT_PLAN,
  SET_ACCESSIBILITY_AND_CURRENT_PLAN,
  SET_PERMISSIONS_LOADING_FAILED,
  UPDATE_DASHBOARD_REPORT_LOADING,
  UPDATE_DASHBOARD_REPORT_FAILED,
  SET_NOTIFICATIONS,
  SET_HAS_ANY_ORDERS_EVER,
} from '../constants';

const initialState = {
  shopInfo: {},
  currentPlan: undefined,
  accessibility: undefined,
  dashboardReport: {},
  notifications: [],
  dashboardReportLoading: true,
  loadingShopInfo: true,
  loadingPermissions: true,
  // null = not checked yet. Fired early (in parallel with shopInfo/permissions,
  // see App.js) instead of waiting for the Dashboard route chunk to mount, so
  // by the time the dashboard actually needs it the answer is often already
  // in — see Dashboard.js's pageLoading/hasAnyOrdersEver seeding.
  hasAnyOrdersEver: null,
};

export const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHOPINFO: {
      // Failure branches dispatch a payload WITHOUT `.data` (just {host}) so
      // the app gate can still open. Don't let that wipe previously-good shop
      // data: a failed focus/cross-tab refetch used to blank shopInfo, and
      // any widgetsV2 settings tab mounted afterwards crashed reading
      // shopInfo.data.* (e.g. ProductEmbedSetting's productEmbedSettings).
      const payload = action?.payload || {};
      const shopInfo =
        payload?.data || !state?.shopInfo?.data
          ? payload
          : { ...state.shopInfo, host: payload.host ?? state.shopInfo.host };
      return {
        ...state,
        shopInfo,
        loadingShopInfo: false,
      };
    }
    case SET_CURRENT_PLAN:
      return {
        ...state,
        currentPlan: action?.payload,
      };
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action?.payload,
      };
    case UPDATE_SHOP_INFO:
      // The shop fields live under `shopInfo.data` (see FETCH_SHOPINFO / the shop-info adaptor),
      // so partial updates must merge into `.data` — not the top-level `shopInfo` — otherwise
      // they're written to a key nothing reads, and re-mounted components show the stale value.
      return {
        ...state,
        shopInfo: {
          ...state?.shopInfo,
          data: { ...state?.shopInfo?.data, ...action?.payload },
        },
      };
    case SET_ACCESSIBILITY_AND_CURRENT_PLAN:
      return {
        ...state,
        ...action?.payload,
        loadingPermissions: false,
      };
    // No prior action cleared loadingPermissions on failure — only the
    // success case above did. Any getPlanUsage() failure (network blip,
    // reauth redirect, timeout — all more common on Safari, see
    // fetchInstance.ts) left it `true` forever, and App.js's
    // `loadingShopInfo || loadingPermissions` gate blocked the entire app
    // behind WholePageLoading with no recovery but a manual refresh.
    case SET_PERMISSIONS_LOADING_FAILED:
      return {
        ...state,
        loadingPermissions: false,
      };
    case UPDATE_DASHBOARD_REPORT:
      return {
        ...state,
        dashboardReportLoading: false,
        dashboardReport: action?.payload,
      };
    case UPDATE_DASHBOARD_REPORT_LOADING:
      return {
        ...state,
        dashboardReportLoading: action?.payload,
      };
    case UPDATE_DASHBOARD_REPORT_FAILED:
      return {
        ...state,
        dashboardReportLoading: false,
        dashboardReport: {},
      };
    case SET_HAS_ANY_ORDERS_EVER:
      return {
        ...state,
        hasAnyOrdersEver: action?.payload,
      };
    case UPDATE_CAN_ADD_ACTION:
      return {
        ...state,
        shopInfo: {
          ...state?.shopInfo,
          data: { ...state?.shopInfo.data, canAddCampaign: action?.payload },
        },
      };
    default:
      return state;
  }
};
